import React, { Component, PropTypes as pt } from 'react';

class TextInput extends Component {
    constructor (props) {
        super(props);

        this.state = {
            value: props.value,
            edited: false
        };
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.edited) {
            this.setState({
                edited: false,
                value: nextProps.value
            });
        }
    }

    render () {

        let value = (this.state.edited) ?
            this.state.value :
            this.props.value;
        // convert boolean false and null values to empty string
        if (value === false || value === null) {
            value = ''
        }

        return <input
            className="form-control"
            placeholder={this.props.placeholder || ''}
            type={this.props.type || 'text'}
            defaultValue={value}
            onChange={function (ev) {
                let value = ev.target.value;
                this.setState({
                    value: value,
                    edited: true
                });
                this.props.storeEdits(value);
            }.bind(this)}
        />;
    }
}

TextInput.propTypes = {};

export default TextInput;
